enum ActionTypes {
    API_TIMER_START = 'API_TIMER/START',
    API_TIMER_RESET = 'API_TIMER/RESET'
}

export const API_TIMER_TYPES = {
    ...ActionTypes
};
